import { toast } from 'sonner';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class OutboxMonitorIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchSummary() {
        try {
            return await this.service.getSummary();
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async fetchList(params = {}) {
        try {
            return await this.service.list(params);
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
